import { render, staticRenderFns } from "./ProductVariationForm.vue?vue&type=template&id=2da2d12f&scoped=true"
import script from "./ProductVariationForm.vue?vue&type=script&lang=js"
export * from "./ProductVariationForm.vue?vue&type=script&lang=js"
import style0 from "./ProductVariationForm.vue?vue&type=style&index=0&id=2da2d12f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da2d12f",
  null
  
)

export default component.exports